// ═══════════════════════════════════════════════════════════════════════════════
//  src/dojo/FeedbackLayer.jsx
//  EL DOJO — las dos capas visuales de retroalimentación
//
//  Vive separado de `useFeedback.js` porque react-refresh exige que un módulo
//  que exporta componentes no exporte nada más. El estado lo administra el
//  hook; aquí sólo se pinta.
// ═══════════════════════════════════════════════════════════════════════════════

/** Destello radial + puntajes flotantes. Se monta dentro de `.dj-shell`. */
export default function FeedbackLayer({ flash, floats }) {
  return (
    <>
      <div
        className={`dj-flash ${flash ? 'dj-on' : ''} ${flash === 'no' ? 'dj-flash-no' : 'dj-flash-go'}`}
        aria-hidden="true"
      />
      {floats.map((f) => (
        <div key={f.id} className={`dj-float ${f.good ? 'dj-good' : 'dj-miss'}`} aria-hidden="true">
          {f.text}
        </div>
      ))}
    </>
  );
}
